import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { HistoriqueService } from 'src/app/services/historique.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  numHistorique : number;
  siteWeb : Object = {};
  description : Object = {};
  logo : Object = {};
  reseauxSociaux : Object[] = [];
  photos : Object[] = [];
  offre : Object = {};
  titreBonPlan : Object =  {};
  phraseAccroche : Object = {};
  detail : object = {};

  constructor(private activatedRoute: ActivatedRoute, private historiqueService : HistoriqueService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.numHistorique = params.historique;
    });

    this.historiqueService.getContenusSpecificState(this.numHistorique).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let input = value["data"];
        this.trierContenus(input);
      }
    });

  }


  /**
   * Trie les contenus selon leur type pour les placer dans leur variable respectif
   */
  trierContenus(input) {
    input.forEach(current => {
      switch(current.designation_type) {
        case 'lien site web' : {
          this.siteWeb = current;
          break;
        }

        case 'descriptif PTL' : {
          this.description = current;
          break;
        }

        case 'logo' : {
          this.logo = current;
          break;
        }

        case 'lien reseaux sociaux' : {
          this.reseauxSociaux.push(current);
          break;
        }

        case 'photo' : {
          this.photos.push(current);
          break;
        }

        case 'offre bon plan' : {
          this.offre = current;
          break;
        }

        case 'titre bon plan' : {
          this.titreBonPlan = current;
          break;
        }

        case 'phrase accroche' : {
          this.phraseAccroche = current;
          break;
        }

        case 'detail' : {
          this.detail = current;
          break;
        }
      }
    });

  }


}
